import { FC } from 'react'

import { Column, Skeleton, Spacer } from '@syconium/little-miss-figgy'

import {
  IconSkeleton,
  IconTitle,
  TextContainer,
  WhyWeLoveIconContainer,
  WhyWeLoveIconSection,
  WhyWeLoveText,
} from './WhyWeLoveSection.styles'

export interface WhyWeLoveSkeletonProps {
  withIcons?: boolean
}

export const WhyWeLoveSkeleton: FC<WhyWeLoveSkeletonProps> = ({ withIcons = true }) => (
  <>
    <Column desktop={12} hasGutter={false} isVerticalAlign>
      <TextContainer>
        <WhyWeLoveText hideIfViewportGreaterThanOrEqualMd asTag='div'>
          <Skeleton height='15px' width='100%' />
          <Spacer height={8} />
          <Skeleton height='15px' width='100%' />
          <Spacer height={8} />
          <Skeleton height='15px' width='100%' />
          <Spacer height={8} />
          <Skeleton height='15px' width='100%' />
        </WhyWeLoveText>

        {withIcons && (
          <WhyWeLoveIconSection>
            {[0, 1, 2].map(key => (
              <WhyWeLoveIconContainer key={key}>
                <IconSkeleton animated />
                <IconTitle asTag='div' textAlign='center'>
                  <Skeleton height='13px' />
                  <Spacer height={7} />
                  <Skeleton height='13px' />
                </IconTitle>
              </WhyWeLoveIconContainer>
            ))}
          </WhyWeLoveIconSection>
        )}
      </TextContainer>
    </Column>
  </>
)
